// See: https://stackoverflow.com/a/37511463
export const removeDiacritics = (value: string) =>
  value.normalize("NFD").replace(/\p{Diacritic}/gu, "");
